import { render, staticRenderFns } from "./BoxIcon.vue?vue&type=template&id=2a661c2c&scoped=true&"
import script from "./BoxIcon.vue?vue&type=script&lang=js&"
export * from "./BoxIcon.vue?vue&type=script&lang=js&"
import style0 from "./BoxIcon.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BoxIcon.vue?vue&type=style&index=1&id=2a661c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a661c2c",
  null
  
)

export default component.exports